import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDrag } from "react-dnd";
import { useHistory } from "react-router-dom";
import { VehicleType, BASE_DROP_TARGET_TYPE } from "./types";
import clsx from "clsx";
import _ from "lodash";
import { useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";
import { consts } from "../../common/consts";

interface VehicleItemProps {
  vehicle: VehicleType;
}

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    backgroundColor: "#02489D",
    flexDirection: "column",
    borderRadius: "4px",
    width: "96px",
    height: "65px",
    marginRight: 7,
    marginBottom: 14,
    alignItems: "center",
    cursor: "pointer",
  },
  isDragging: {
    opacity: 0,
  },
  baseName: {
    color: "#fff",
    fontSize: "20px",
    fontWeight: 900,
    marginTop: 13,
  },
  shiftType: {
    color: "#fff",
    fontSize: "12px",
    marginTop: 2,
  },
}));

const VehicleItem: React.FC<VehicleItemProps> = ({ vehicle }): JSX.Element => {
  const style = useStyles();
  const history = useHistory();
  const { authStore } = useSelector((state: RootState) => state);
  const [isAdmin, setIsAdmin] = React.useState<any>(authStore?.data?.IsAdmin || authStore.data?.role.split(",").includes(consts.Permissions.SMAAdminManageVehicles));

  const [{ isDragging }, drag] = useDrag({
    type: BASE_DROP_TARGET_TYPE,
    item: () => {
      return vehicle;
    },
    collect: (monitor: any) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const editVehicle = (vehicleId: string) => {
    if(isAdmin)
      history.push({
        pathname: `/settings/vehicles/edit/${vehicleId}`,
      });
    else
      history.push({
        pathname: `/managevehicles/edit/${vehicleId}`,
      });
  };

  return (
    <div
      ref={drag}
      className={clsx(style.root, {
        [style.isDragging]: isDragging,
      })}
      onClick={() => editVehicle(vehicle.vehicleId!!)}
    >
      <div className={style.baseName}>{vehicle.callSign}</div>
      <div className={style.shiftType}>{vehicle.suitableForHealthshare ? "HealthShare" : ""}</div>
    </div>
  );
};

export default VehicleItem;
